import { type UseQueryResult, useQuery } from 'react-query';
import { type TableParamsType } from '../../types/common';
import { ParticipantBrokerAccountUpdatedHistoryService } from '@wealthlane/api-services/wealthlane-customer-service';
import { Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_ParticipantBrokerAccountHistoryDto } from '@wealthlane/api-services/wealthlane-customer-service';

const useGetParticipantBrokerAccountHistory = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  // tableInfo: TableParamsType,
  participantBrokerAccountId: string
): UseQueryResult<
  | Array<Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_ParticipantBrokerAccountHistoryDto>
  | undefined,
  unknown
> => {
  // const { filter, sorting, skipCount, maxResultCount } = tableInfo;

  const switchSandboxList = useQuery(
    ['getParticipantBrokerAccountHistory', participantBrokerAccountId],
    async () => {
      return await handleRequest(
        ParticipantBrokerAccountUpdatedHistoryService.getApiCustomerApiAppParticipantBrokerAccountUpdatedHistoryBrokerAccountUpdatedHistoryByParticipantBrokerAccountId(
          participantBrokerAccountId
          // filter
          // sorting,
          // skipCount,
          // maxResultCount
        )
      );
    }
  );

  return switchSandboxList;
};

export default useGetParticipantBrokerAccountHistory;
